import React from 'react';
import { motion } from 'framer-motion';
const projects = [{
  title: 'Apex Fitness Center',
  category: 'Local Business / Gym',
  image: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
  color: 'from-blue-600/90 to-blue-800/90'
}, {
  title: 'Lumina Tech Solutions',
  category: 'B2B SaaS / Tech',
  image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
  color: 'from-blue-600/90 to-blue-800/90'
}, {
  title: 'Artisan Coffee Roasters',
  category: 'E-Commerce / Retail',
  image: 'https://images.unsplash.com/photo-1497935586351-b67a49e012bf?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
  color: 'from-blue-600/90 to-blue-800/90'
}, {
  title: 'Elevate Real Estate',
  category: 'Corporate / Agency',
  image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
  color: 'from-blue-600/90 to-blue-800/90'
}];
export function Portfolio() {
  return <section id="portfolio" className="py-24 bg-black border-y border-white/5" data-id="element-276">
      <div className="container mx-auto px-6 md:px-12" data-id="element-277">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6" data-id="element-278">
          <div className="max-w-2xl" data-id="element-279">
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-6" data-id="element-280">
              Recent <span className="text-gradient" data-id="element-281">Work</span>
            </h2>
            <p className="text-lg text-[#FFFFFF]" data-id="element-282">
              A selection of high-performing websites built to drive traffic,
              generate leads, and establish brand authority.
            </p>
          </div>
          <a href="#contact" className="hidden md:inline-flex px-6 py-3 rounded-lg bg-white/5 hover:bg-white/10 border border-white/10 text-white font-medium transition-all" data-id="element-283">
            Start Your Project
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-284">
          {projects.map((project, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="relative rounded-2xl overflow-hidden aspect-[4/3] bg-[#111118] border border-white/5" data-id="element-285">
              <img src={project.image} alt={project.title} className="w-full h-full object-cover" data-id="element-286" />

              {/* Static Caption */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent flex flex-col justify-end p-8 pointer-events-none" data-id="element-287">
                <p className="text-white/90 text-sm font-medium mb-2 uppercase tracking-wider" data-id="element-288">
                  {project.category}
                </p>
                <h3 className="text-3xl font-heading font-bold text-white" data-id="element-289">
                  {project.title}
                </h3>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}